export const DEFAULT_DELAY = 500;
export const SEARCH_DELAY = 300;
